import { Box } from '@chakra-ui/react'
import React from 'react'
import ClassSchedule from '../components/ClassSchedule'

const ClassScheduleScreen = () => {
  return (
    <Box>
      <ClassSchedule/>
    </Box>
  )
}

export default ClassScheduleScreen
